import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [3, 1],
        components: [
          [
            {
              variant: "layout",
              data: {
                type: "videoSlider",
                options: {
                  src: `${config.ASSETS_URL}/03/11/principle/sound-pressure.mov`,
                  startLabel: "1.1 kHz",
                  endLabel: "22.1 kHz",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "To simulate head related transfer functions (HRTFs), the reciprocal principle is used, where the transfer function from source to receiver is the same as from receiver to source. In this way a monopole in the ear channel can be modeled as sound source. Hence the sound pressure or transfer function can be calculated more efficiently from any point around the ear. In this picture the sound pressure level at the ear surface is visualized.",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                    },
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
